import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconExpand(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M7 17h3c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0 1 10 19H6a.967.967 0 0 1-.713-.288A.968.968 0 0 1 5 18v-4c0-.283.096-.52.287-.713A.967.967 0 0 1 6 13c.283 0 .52.096.713.287.191.192.287.43.287.713v3ZM17 7h-3a.968.968 0 0 1-.713-.287A.967.967 0 0 1 13 6c0-.283.096-.52.287-.713A.968.968 0 0 1 14 5h4c.283 0 .52.096.712.287.192.192.288.43.288.713v4c0 .283-.096.52-.288.713A.968.968 0 0 1 18 11a.968.968 0 0 1-.712-.287A.968.968 0 0 1 17 10V7Z"
      />
    </BaseIcon>
  );
}
